import { put, takeEvery } from "redux-saga/effects";

import cmsService from "../../../services/cms";
import { getCmsStart, getCmsSuccess, getCmsFailure } from "../../redux/cms";
// import { showErrorMessage } from "../../redux/toast";

function* cmsWatcher() {
  yield takeEvery(getCmsStart.type, cmsWorker);
}

function* cmsWorker(action) {
  try {
    const { data, error } = yield cmsService.getCmsData({
      ...action.payload,
      isSignUpCms: null
    });
    if (!error) {
      if (action.payload?.isSignUpCms) {
        yield put(getCmsSuccess({ isSignUpCms: true, signupData: data }));
      } else {
        yield put(getCmsSuccess(data));
      }
    }
    if (error) {
      // yield put(showErrorMessage({ msg: error.message }));
      yield put(getCmsFailure());
    }
  } catch (error) {
    // yield put(showErrorMessage({ msg: error.message }));
    yield put(getCmsFailure());
  }
}

export default cmsWatcher;
